module.exports = "https://web-assets.ifttt.com/packs/media/access_applet_card/info-drawer-bullet-manage-72eb2585.svg";